import { StyleSheet } from 'aphrodite';
import { destructive } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		maxWidth: '100%',
		boxSizing: `border-box`,
		alignItems: 'center',
	},
	tableHeaderSelectBoxTrigger: {
		border: '1px solid #979797',
		borderRadius: 8,
		height: 30,
		padding: '0 10px',
	},
	tableHeaderSelectBox: {
		marginBottom: 8,
		width: 200,
	},
	tableOverrides: {
		maxWidth: '100%',
		overflow: 'scroll',
		display: 'inline-block',
		minHeight: 400,
		width: `auto`,
	},
	headerTitle: {},
	headerSubtitle: {},
	headerArrow: {},
	tableSampleMessage: {},
	tableHeaderSelectFilter: {},
	errorMessage: {
		color: destructive,
	},
	mergeByNameContainer: {
		marginTop: 16,
		marginBottom: 16,
	},
	checkboxText: {
		fontSize: 14,
	},
});
